import React from "react";
import DashboardConstant from "@views/Pages/Dashboard/landing-image.constant";
import headerIcon from "../../assets/img/headerIcon.svg";
interface Props {
    title?: string;
    buttonText?: string;
    showLogo?: boolean;
    isDashboard?: boolean;
    classname?: string;
    images?: {
        logoImage1?: string;
    };
    theme?: {
        logoImage1?: string;
    };
    subtitle?: string;
    children?: React.ReactNode;
}

const HeroRaffle = ({ title, buttonText, showLogo, images, theme, subtitle, isDashboard, classname, children }: Props) => {
    return (
        <>
            {isDashboard ? <section className={`${classname} flex flex-col md:flex-row justify-between p-10 text-center text-[var(--text-color)] bg-[var(--tertiary-color,none)] bg-cover bg-no-repeat border-b-[3px] border-transparent md:mt-16 md:justify-start items-start`} >

                {showLogo && (
                    <div className="flex flex-col md:items-center md:justify-center justify-start">
                        <img
                            alt="Logo"
                            className="hidden md:block"
                            style={{ width: 140 }}
                            src={
                                images?.logoImage1 ?? theme?.logoImage1 ?? DashboardConstant.Robot
                            }
                        />
                        <div className="text-white md:!text-[#1b5c29] mt-0 md:mt-4 text-lg uppercase bg-[#1b5c29] md:bg-transparent text-nowrap rounded-2xl p-2 font-semibold">
                            <span>WINNERS CLUB</span>
                        </div>
                    </div>
                )}
                <div className="flex flex-col gap-4">
                    <h2 className={`w-full text-left text-2xl md:text-7xl font-bold leading-[1.5] ${isDashboard ? "md:!text-right" : ""}`}>
                        {title}{" "}
                        <svg
                            width="47"
                            height="52"
                            viewBox="0 0 47 52"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{ display: "inline-block", verticalAlign: "middle" }}
                        >
                            <path
                                d="M27.888 2.45059C12.8782 20.9287 25.9208 38.3791 35.8568 42.0705C45.5509 25.0569 43.4957 15.6492 27.888 2.45059Z"
                                fill="#52B12F"
                            />
                            <path
                                d="M27.8877 2.45068C43.4954 15.6493 45.5505 25.057 35.8565 42.0706L27.8877 2.45068Z"
                                fill="#1B5C29"
                            />
                            <path
                                d="M1.77362 38.8172C9.80773 53.9189 25.0051 50.165 30.2266 44.6204C21.6755 33.4467 14.8739 32.1767 1.77362 38.8172Z"
                                fill="#52B12F"
                            />
                            <path
                                d="M1.77358 38.8175C14.8738 32.1769 21.6755 33.447 30.2265 44.6206L1.77358 38.8175Z"
                                fill="#1B5C29"
                            />
                        </svg>
                    </h2>

                    {subtitle !== "" && <h2 className={`font-normal text-left ${isDashboard ? "md:!text-right" : ""}`}>{subtitle}</h2>}
                </div>
            </section > :
                <div className="p-10 bg-[#EAF0D5] mt-hero">
                    <div className="flex flex-col items-start gap-2">
                        <div className={`${buttonText ? "flex justify-between w-full items-center" : ""}`}>
                            <div className="flex relative w-fit">
                                <h1 className="text-3xl sm:text-4xl md:text-5xl !text-[#343535]">{title}</h1>
                                <span className="absolute -top-6 -right-6">
                                    <img src={headerIcon} alt="icon" />
                                </span>
                            </div>
                            {buttonText && <button
                                className="p-2 text-black bg-white border-[#4b975b] rounded-lg cursor-pointer transition-all duration-300 ease-in-out hover:bg-[#ff6b81] flex items-center justify-center whitespace-nowrap gap-2" ><span>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 22 14"
                                        fill="none"
                                        className="w-6 h-3 sm:w-5"
                                    >
                                        <path
                                            d="M19.8575 0.75H16.025C15.8375 0.75 15.68 0.8805 15.6275 1.065C15.485 1.56375 15.0275 1.93275 14.495 1.93275C13.9625 1.93275 13.505 1.572 13.3625 1.065C13.3396 0.976345 13.2884 0.89759 13.2167 0.840726C13.1449 0.783862 13.0565 0.752003 12.965 0.75H2.1425C1.235 0.75 0.5 1.50225 0.5 2.4315V10.3185C0.5 11.2477 1.235 12 2.1425 12H12.965C13.1525 12 13.31 11.8695 13.3625 11.685C13.505 11.1862 13.9625 10.8173 14.495 10.8173C15.0275 10.8173 15.485 11.178 15.6275 11.685C15.68 11.8695 15.8375 12 16.025 12H19.8575C20.765 12 21.5 11.2477 21.5 10.3185V2.4315C21.5 1.50225 20.765 0.75 19.8575 0.75ZM14.495 9.4815C13.8425 9.4815 13.25 8.92425 13.25 8.256C13.25 7.58775 13.8425 7.0545 14.495 7.0545C15.1475 7.0545 15.692 7.58775 15.692 8.256C15.692 8.9235 15.1475 9.4815 14.495 9.4815ZM14.495 5.703C13.8425 5.703 13.259 5.15775 13.259 4.4895C13.259 3.822 13.8425 3.27675 14.495 3.27675C15.1475 3.27675 15.7108 3.822 15.7108 4.4895C15.7108 5.15775 15.1475 5.703 14.495 5.703Z"
                                            className="fill-[#F9C23C]"
                                        />
                                        <path
                                            d="M6.587 4.49999H3.413C3.04625 4.49999 2.75 4.17674 2.75 3.77624C2.75 3.37574 3.04625 3.05249 3.413 3.05249H6.587C6.95375 3.05249 7.25 3.37574 7.25 3.77624C7.25 4.18499 6.95375 4.49999 6.587 4.49999ZM3.188 8.24999H10.5695C10.8042 8.24999 11.0075 8.08274 11 7.87499C11 7.66724 10.805 7.49999 10.562 7.49999H3.188C2.94575 7.49999 2.75 7.66724 2.75 7.87499C2.75 8.08274 2.945 8.24999 3.188 8.24999ZM3.188 9.74999H10.5695C10.8042 9.74999 11.0075 9.57599 11 9.37499C11 9.16724 10.805 8.99999 10.562 8.99999H3.188C2.94575 8.99999 2.75 9.16724 2.75 9.37499C2.75 9.58274 2.945 9.74999 3.188 9.74999ZM17.5543 6.74999H19.4457C19.7533 6.74999 20 6.99749 20 7.30424V9.19574C20 9.50324 19.7525 9.74999 19.4457 9.74999H17.555C17.4822 9.75019 17.41 9.73599 17.3427 9.7082C17.2753 9.68042 17.2142 9.6396 17.1626 9.5881C17.1111 9.53659 17.0703 9.47541 17.0425 9.40808C17.0148 9.34074 17.0006 9.26858 17.0007 9.19574V7.30499C17.0007 6.99749 17.2483 6.75074 17.555 6.75074"
                                            className="fill-[#D3883E]"
                                        />
                                    </svg></span>
                                {buttonText}
                            </button>
                            }
                        </div>
                        {subtitle !== "" && <h2 className={`font-normal text-left !text-[18px] !text-[#343535] mb-0 ${isDashboard ? "md:!text-right" : ""}`}>{subtitle}</h2>}
                        {children && <div className="mt-4 w-full">{children}</div>}
                    </div>

                </div>}
        </>
    );
};

export default HeroRaffle;